import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Segmented, Space } from 'ui';
import type { EventTimelineType } from 'features/events';
import { DeclinedEvents } from './declined-events';
import { useGetTabOptions } from './hooks';

export type EventsType = EventTimelineType;

type P = {
  getPathToEventDetail: (id: string) => string;
  isOpened: boolean;
  onCancel: () => void;
};

const DEFAULT_TYPE = 'upcoming';

const DeclinedEventsModal = ({ getPathToEventDetail, isOpened, onCancel }: P) => {
  const [type, setType] = useState<EventsType>(DEFAULT_TYPE);
  const { t } = useTranslation();
  const options = useGetTabOptions();

  return (
    <Modal
      isOpened={isOpened}
      onCancel={() => {
        setType(DEFAULT_TYPE);
        onCancel();
      }}
      title={type === 'upcoming' ? t('Upcoming declined events') : t('Past declined events')}
      width="large"
    >
      <Modal.HugContent>
        <Space block orientation="vertical" size="large">
          <Segmented onChange={setType} options={options} value={type} />
          <DeclinedEvents getPathToEventDetail={getPathToEventDetail} type={type} />
        </Space>
      </Modal.HugContent>
    </Modal>
  );
};

export default DeclinedEventsModal;
